import { Component, Input, OnInit } from '@angular/core'
import { LogEvent } from 'src/app/interfaces/log'
import { LogService } from 'src/app/services/log/log.service'
import { RouterService } from 'src/app/services/router/router.service'

@Component({
  selector: 'home-header',
  templateUrl: './home-header.component.html',
  styleUrls: ['./home-header.component.scss'],
})
export class HomeHeaderComponent implements OnInit {
  constructor(private logService: LogService, private routerService: RouterService) {}

  @Input() showLoginButton = true
  @Input() showDrawerButton = true

  ngOnInit() {}

  onClickLogo(): void {
    this.logService.eventLogging(LogEvent.HEADER_LOGO_CLICKED, { from: location.pathname })
    this.routerService.navigate('')
  }
}
